import React from 'react';
import TextInfo, {
  COLOR,
  FONT_TYPE,
  SIZE,
  KIND_TEXT,
  SEGMENT,
  HEADING_LEVEL,
} from '@bit/gerenciatd.unifiedcomponents.text-info';

import '../VideoModules.scss';

export const COMPONENT_NAME = 'ContainerText';

const ContainerText = ({ claim, subClaim, align }) => {
  return (
    <div className={`VideoModules__info VideoModules__info${align === 'reverse' ? 'Right' : 'Left'}`}>
      <div className="VideoModules__info-text">
        <TextInfo
          kind={KIND_TEXT.HEADING}
          level={HEADING_LEVEL.H2}
          size={SIZE.TITLE3}
          fontType={FONT_TYPE.REGULAR}
          color={COLOR.GREEN_DARK}
          text={claim}
          segment={SEGMENT.EMP}
          className="VideoModules__info-text_title"
          tabletProps={{
            size: SIZE.DISPLAY3,
          }}
        />
        <TextInfo
          kind={KIND_TEXT.PARAGRAPH}
          size={SIZE.TITLE6}
          fontType={FONT_TYPE.LIGHT}
          color={COLOR.GREEN_DARK}
          text={subClaim}
          segment={SEGMENT.EMP}
          className="VideoModules__info-text_description"
          tabletProps={{
            size: SIZE.TITLE45,
          }}
        />
      </div>
    </div>
  );
};

export default ContainerText;
